import * as React from 'react'
function SvgLockClosed(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20 4c-4.4 0-8 3.6-8 8v3c-2.4 2.2-4 5.4-4 9 0 6.6 5.4 12 12 12s12-5.4 12-12c0-3.6-1.6-6.8-4-9v-3c0-4.4-3.6-8-8-8zm2 21.4V30h-4v-4.6c-1.2-.6-2-2-2-3.4 0-2.2 1.8-4 4-4s4 1.8 4 4c0 1.4-.8 2.8-2 3.4zm2-12.6c-1.2-.6-2.6-.8-4-.8s-2.8.2-4 .8V12c0-2.2 1.8-4 4-4s4 1.8 4 4v.8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgLockClosed
